import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import BlogData from "../Data/BlogData.json";
import { Link } from "react-router-dom";
const BlogSlider = () => {
  return (
    <>
      <section className="blog-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="blog-title">
                <h3>Our Blogs</h3>
                <p>
                  Information technology makes it easier to connect faster and
                  facilitates communicating when and where required.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="blog-slider">
                <Swiper
                  modules={[Autoplay, Navigation]}
                  spaceBetween={24}
                  slidesPerView={3}
                  navigation
                  loop={true}
                  autoplay={true}
                  breakpoints={{
                    // when window width is >= 640px
                    320: {
                      width: 320,
                      slidesPerView: 1,
                    },
                    // when window width is >= 768px
                    768: {
                      width: 768,
                      slidesPerView: 2,
                    },
                  }}
                >
                  {BlogData.slice(0, 3).map((SingleBlogCard) => (
                    <SwiperSlide key={SingleBlogCard.id}>
                      <div class="single-blog">
                        <div class="blog-head">
                          <img src={SingleBlogCard.img} alt="#" />
                        </div>
                        <div class="blog-content">
                          <ul class="blog-meta">
                            <li class="dot">{SingleBlogCard.date}</li>
                            <li>{SingleBlogCard.time}</li>
                          </ul>
                          <h3 class="b-title">
                            <Link to="/blogsingle">{SingleBlogCard.title}</Link>
                          </h3>
                          <div class="blog-btn">
                            <Link to="blogsingle" class="theme-btn primary">
                              <i class="icofont-arrow-right"></i>Read more
                            </Link>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="blog-bottom-btn">
                <Link to="/blog" className="theme-btn">
                  Read all Blog
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogSlider;
